import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../theme/colors';

export const useEntityHistoryReferencesStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    padding: '2px 0',
    fontSize: '13px'
  },
  reference: {
    color: Colors.midGray
  },
  label: {
    color: Colors.darkGray,
    fontWeight: 500
  }
});
